<template>
  <div class="mx-4">
    <vs-row
      vs-lg="12"
      class="my-6 flex items-start"
      v-for="(i, index) in boardSteps"
      :key="index"
    >
      <vs-col
        class="flex relative justify-center"
        vs-lg="1"
        vs-sm="1"
        vs-xs="1"
      >
        <div
          class="icon relative items-center z-10"
          :class="
            currentUserBoardStepProgress(i.id) &&
            currentUserBoardStepProgress(i.id).completionPercentage > 0
              ? 'active-icon'
              : 'inactive-icon'
          "
        >
          <vs-avatar
            v-if="
              currentUserBoardStepProgress(i.id) &&
              currentUserBoardStepProgress(i.id).completionPercentage > 0
            "
            color="#44CC88"
            icon="done"
          />
          <vs-avatar
            v-else
            color="#f2c244"
            size="30px"
            :text="`${index + 1}`"
          />
        </div>
        <div
          class="absolute vertical-line"
          :class="[
            index === appSteps.length - 1 ? 'hidden' : 'block',
            currentUserBoardStepProgress(i.id) &&
            currentUserBoardStepProgress(i.id).completionPercentage > 0
              ? 'active-border'
              : 'inactive-border',
          ]"
        />
      </vs-col>

      <vs-col class="mt-0 ml-6 md:m-9 md:mt-0 md:mr-0 lg:ml-4" vs-w="10">
        <div
          v-if="currentBoardUserDetails && currentBoardUserDetails.boardData"
        >
          <p
            class="cursor-pointer font-semibold text-lg"
            style="color: #383b46 !important"
          >
            <b> {{ i.title }}</b>
          </p>
          <span class="activity-desc text-base" v-if="i.desc">{{
            i.desc
          }}</span>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
var moment = require("moment");
import Datepicker from "vuejs-datepicker";
import marketplaceList from "@/assets/data/marketplace-list.js";
import appFlow from "@/assets/data/app-flow.js";
import appConfig from "@/assets/data/app-config.js";
import allTimeZone from "@/assets/data/allTimeZone";
import vSelect from "vue-select";
import _ from "lodash";

export default {
  name: "user-board-step",
  props: {
    installedApps: {
      type: Array,
      default: () => [],
    },
    appId: {
      type: String,
    },
    currentUserBoardProgress: {
      type: Object,
    },
    boardSteps: {
      type: Array,
      required: true,
    },
  },
  components: {
    Datepicker,
    vSelect,
  },
  data() {
    return {
      appFlow,
      appConfig,
      marketplaceList,
      vTimeline: {
        icon: "CheckIcon",
        color: "primary",
      },
      userLevelBoardAnalytics: {},
      magicLinks: {},
      videowikiCastPopup: {},
      videowikiRoomPopup: {},
      startD: this.tomorrowDate(),
      cast: {
        name: "",
        description: "",
        start_now: true,
        startMinute: "0",
        startHour: "0",
        startDate: this.tomorrowDate(),
        timezone: null,
        scheduleTime: "",
        schedule_now: false,
      },

      allTimeZoneOptions: allTimeZone,
      disabledDates: {
        to: moment().subtract(1, "days").toDate(),
      },
      rooms: [],
      file: "",
      color: "#f2c244",
      photoLinks: [],
      selectedImage: "",
      openCastPopup: false,
      openRoomPopup: false,
      openCustomRoomPopup: false,
      casts: [],
      orgBoardUsersArray: [],
      moment: moment,
      skeleton: true,
      allCasts: [],
      allRooms: [],
      castRunningStatus: "live",
      roomRunningStatus: "live",
      filteredCasts: [],
      appSteps: [],
      filteredRooms: [],
    };
  },
  computed: {
    appSeries() {
      let _installedApps = this.installedApps.filter((value) =>
        this.appFlow.series.includes(value)
      );
      return _installedApps.sort(
        (a, b) =>
          this.appFlow.series.indexOf(a) - this.appFlow.series.indexOf(b)
      );
    },
    currentBoardUserDetails() {
      return this.$store.state.boards.currentBoardUserDetails;
    },
    autoLoginToken() {
      return this.$store.state.boards.userBoardData.youlabToken;
    },
    userProgress() {
      return this.$store.state.boards.userBoardData.progress;
    },
    activateFeedback() {
      return this.autoLoginToken && this.userProgress >= 1;
    },
    activateCompetency() {
      return this.autoLoginToken && this.userProgress >= 2;
    },
    userData() {
      const ud = this.$store.state.users.data;
      if (ud.email) return ud;
      else return this.$store.state.auth.user;
    },
    accessToken() {
      return this.$store.state.auth.accessToken;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    castInstalledBoardsName() {
      return this.$store.state.videowiki.castInstalledBoardsName;
    },
    currentUserLevelBoard() {
      return this.$store.state.boards.currentUserLevelBoard;
    },
    isCastRunning() {
      return this.$store.state.videowiki.isCastRunning;
    },
    userLevelBoards() {
      return this.$store.state.boards.userLevelBoards;
    },
    joinCastPopup() {
      return this.$store.state.videowiki.joinCastPopup;
    },
    boardUserConfigData() {
      return this.$store.state.boards.currentBoardUserDetails
        .boardUserConfigData;
    },
    joinRoomPopup() {
      return this.$store.state.videowiki.joinRoomPopup;
    },
    backgroundLinks() {
      return this.$store.state.videowiki.backLinks;
    },
  },
  watch: {
    boardSteps: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
    magicLinks: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
    boardId() {
      this.getBoardUsers();
    },
    currentUserBoardProgress: {
      handler(newVal) {
        if (newVal) {
          if (
            newVal.journey &&
            newVal.journey.steps &&
            this.appId === "journey"
          ) {
            let journeySteps = [];
            for (let i = 0; i < newVal.journey.steps.length; i++) {
              for (let j = 0; j < this.appSteps.length; j++) {
                if (newVal.journey.steps[i].id === this.appSteps[j].id) {
                  journeySteps.push(this.appSteps[j]);
                }
              }
            }
            this.appSteps = journeySteps;
          }

          if (
            newVal &&
            this.appId === "coach" &&
            this.boardUserConfigData &&
            (this.boardUserConfigData.userType === "coach" ||
              this.boardUserConfigData.userType === "mentor")
          ) {
            return (this.appSteps =
              this.appFlow.flow[this.appId].steps["coach"].steps);
          } else if (
            this.appId === "coach" &&
            this.boardUserConfigData &&
            (this.boardUserConfigData.userType === "trainee" ||
              this.boardUserConfigData.userType === "player")
          ) {
            return (this.appSteps =
              this.appFlow.flow[this.appId].steps["trainee"].steps);
          }
        }
      },
      immediate: true,
      deep: true,
    },
    currentBoardUserDetails(newVal) {
      if (newVal) {
        this.$store
          .dispatch("boards/fetchUserLevelBoardAnalytics", newVal._id)
          .then((res) => {
            this.userLevelBoardAnalytics = res.data;
          });
      }
    },
  },
  methods: {
    setSelectedImage(i) {
      this.selectedImage = i;
    },
    submitFile(event) {
      this.file = event.target.files[0];
    },
    async getBackgrounds() {
      this.$store
        .dispatch("videowiki/getBackgroundLinks")
        .then((res) => {
          this.photoLinks = res;
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error occured while getting backgrounds",
            text: "",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            time: 8000,
          });
          throw err;
        })
        .finally(() => {
          this.openCastPopup = false;
        });
    },

    getAppFlowById(id) {
      return this.appFlow.flow[id];
    },
    getAppDataById(id) {
      const appIndex = this.marketplaceList.findIndex((app) => {
        return app.id === id;
      });
      if (appIndex !== -1) return this.marketplaceList[appIndex];
      else return appIndex;
    },
    getBoardUsers() {
      this.searchedUserArray = [];
      this.$store
        .dispatch("boards/fetchAllBoardUsers", this.boardId)
        .then((res) => {
          this.orgBoardUsersArray = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          ////console.log("err", err);
        });
    },
    sortRule(cast) {
      return moment
        .utc(`${cast.date} ${cast.time}`, moment.defaultFormat)
        .fromNow()
        .includes("ago");
    },
    activateChatBot() {
      let slug = this.currentUserLevelBoard.orgData.slug;
      let chatBotId = this.appConfig.alex[slug].chatBotFormId;
      let boturl = `https://library.getboarded.com/bot?form_id=${chatBotId}&first_name=${encodeURIComponent(
        `${this.userData.firstName}`
      )}&email=${this.userData.email}.com&org=${
        this.currentUserLevelBoard.orgData.slug
      }&gbuid=${this.userData._id}&gborgid=${
        this.currentUserLevelBoard.orgData._id
      }`;
      window.open(boturl, "_blank");
    },
    openEditor() {
      let slug = this.currentUserLevelBoard.orgData.slug;
      let editorUrl = `https://editor.getboarded.com/oauth-callback?organization=${slug}&token=${this.accessToken}&userId=${this.userData._id}`;
      window.open(editorUrl, "_blank");
    },
    currentUserBoardStepProgress(appId, stepId) {
      if (stepId === "appInstalled") {
        return {
          completionPercentage: 100,
        };
      } else if (
        !this.currentUserBoardProgress ||
        !this.currentUserBoardProgress[appId] ||
        !this.currentUserBoardProgress[appId].steps
      ) {
        return {
          completionPercentage: 0,
        };
      }

      return this.currentUserBoardProgress[appId].steps.find(
        (step) => step.id === stepId
      );
    },
  },
};
</script>

<style lang="scss">
.cp_wrapper {
  padding: 0;
  margin: 0;
  width: 3.5em;
  box-sizing: border-box;
}

.cp {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-top: 2px;
  height: 50px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.cp::-webkit-color-swatch {
  border-radius: 5px;
  border: none;
}

.cp::-moz-color-swatch {
  border-radius: 10px;
  border: none;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.active p.s-head {
  color: #f29300;
}

.step-headline.active,
.active h5 {
  color: #231d4f;
}

.active p {
  color: #848199;
}

.inactive {
  color: #ccc !important;
}

.inactive p {
  color: #ccc !important;
}

.span.inactive h5,
.inactive p {
  color: #ccc !important;
}

.grey-out {
  color: #cccccc !important;
  pointer-events: none !important;
}

.active {
  &-icon {
    background: #44cc88;
    box-shadow: 0px 0px 0px 5px #c8ffe3;
  }

  &-border {
    border-color: #c8ffe3 !important;
  }
}

.inactive {
  &-icon {
    background: #f2c244;
    box-shadow: 0px 0px 0px 5px #ffefc7;
  }

  &-border {
    border-color: #ffefc7 !important;
  }
}

.icon {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vertical-line {
  border-left: 3px solid;
  height: 10em;
}

.timezone-select {
  padding: 0.6rem;
}

.vs-con-textarea,
.vs__dropdown-toggle,
.vdp-datepicker input {
  background: #fbfbfc;
  border: 1px solid #ebedf0 !important;
  border-radius: 6px;
}

.vdp-datepicker .cell.selected {
  background: #7367f0 !important;
}

@media only screen and (max-width: 991px) {
  .vertical-line {
    height: 15em;
  }
}

@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>

<style scoped>
.join-popup >>> .vs-popup {
  height: 60%;
}

.join-popup >>> .vs-popup--content {
  height: 80%;
}

.con-vs-avatar >>> .vs-avatar--text {
  font-size: 1.25rem;
}

@media only screen and (max-width: 660px) {
  .join-popup >>> .vs-popup {
    height: 92%;
  }

  .join-popup >>> .vs-popup--content {
    height: 90%;
  }

  .vs-con-table >>> table {
    width: 150%;
  }
}
</style>
